<div class="modal-body">
  <rl-loading-banner
    [isLoading]="hierarchyEditor.isLoading"
  ></rl-loading-banner>

  <div
    *ngIf="hierarchyEditor.loadingError ? true : false"
    class="alert alert-danger qa-loading-error"
    role="alert"
  >
    <strong i18n="@@nodesEditor-status-errorLoading">Error!</strong>
    <ng-container i18n="@@nodesEditor-status-errorLoadingPleaseRetry"
      >There was an error loading hierarchy nodes for your list. Please try
      again.</ng-container
    >
  </div>

  <div
    *ngIf="hierarchyEditor.savingError ? true : false"
    class="alert alert-danger qa-saving-error"
    role="alert"
  >
    <strong i18n="@@nodesEditor-status-errorSaving">Error!</strong>
    <ng-container i18n="@@nodesEditor-status-errorSavingPleaseRetry"
      >There was an error saving hierarchy nodes for your list. Please try
      again.</ng-container
    >
  </div>

  <div
    *ngIf="!isHierarchyUpdateEnabled"
    class="alert alert-danger qa-hierarchy-disabled-alert"
    i18n="@@nodesEditor-status-hierarchyUpdateDisabled"
  >
    Hierarchy updates are currently in progress, preventing immediate updates of
    hierarchy links and student numbers. Please try again later.
  </div>

  <ng-container *ngIf="hierarchyEditor.hierarchyAndStudentNumbers">
    <div
      class="c-nodes-editor__form"
      [class.has-permission-to-edit-nodes]="hasAttachToHierarchyPermission"
    >
      <rl-node-search-field
        *ngIf="hasAttachToHierarchyPermission"
        [disabled]="areFormInteractionsDisabled"
        (nodeSelected)="addNode($event)"
        class="c-nodes-editor__form__search"
      >
      </rl-node-search-field>

      <div
        *ngIf="haveLegacyNumbersBeenTransferred"
        class="alert alert-warning c-nodes-editor__form__transfer-warning qa-legacy-transfer"
      >
        <ng-container
          i18n="@@nodesEditor-legacy-message-legacyNumbersTransferred"
        >
          There are student numbers previously assigned to the list that may
          have been linked with a single or multiple nodes. Saving here will
          re-save them with student numbers against each node. The total student
          numbers added previously will be assigned to the first node linked.
        </ng-container>
      </div>

      <div
        *ngIf="willListBoundNumbersBeTransferred"
        class="alert alert-warning c-nodes-editor__form__transfer-warning qa-list-transfer"
      >
        <ng-container
          i18n="@@nodesEditor-legacy-message-listNumbersTransferWarning"
        >
          There are student numbers previously assigned to the list. Linking a
          list to a node will mean this number is assigned automatically to the
          new node.
        </ng-container>
      </div>

      <form [formGroup]="hierarchyAndStudentNumbersForm">
        <table class="table c-nodes-editor__form__table">
          <thead>
            <tr>
              <th i18n="@@nodesEditor-heading-type">Type</th>
              <th i18n="@@nodesEditor-heading-name">Name</th>
              <th
                id="nodes-editor-thead-student-numbers"
                i18n="@@nodesEditor-heading-studentNumbers"
              >
                Student numbers
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngIf="!(nodesAndOverridesFormArray?.controls?.length > 0)"
              class="qa-list-only-numbers"
            >
              <td
                class="c-nodes-editor__form__table__node-type"
                i18n="@@nodesEditor-unlinked-label-unlinked"
              >
                Unlinked
              </td>
              <td
                class="c-nodes-editor__form__table__node-title"
                i18n="@@nodesEditor-unlinked-message-notLinkedToHierarchy"
              >
                Not linked to the hierarchy
              </td>
              <td class="c-nodes-editor__form__table__student-numbers">
                <div class="form-inline">
                  <input
                    type="number"
                    step="1"
                    formControlName="listStudentNumbers"
                    class="form-control"
                    aria-labelledby="nodes-editor-thead-student-numbers"
                  />
                </div>
              </td>
            </tr>
            <tr
              formArrayName="nodesAndOverrides"
              *ngFor="
                let nodeAndOverride of nodesAndOverridesFormArray.controls;
                index as index;
                trackBy as trackByFn
              "
              class="qa-node-details"
            >
              <td class="c-nodes-editor__form__table__node-type">
                {{ nodeAndOverride.value.node.node_type }}
              </td>
              <td class="c-nodes-editor__form__table__node-title">
                {{ nodeAndOverride.value.node.code }} -
                {{ nodeAndOverride.value.node.title }}
              </td>
              <td
                [formGroupName]="index"
                class="c-nodes-editor__form__table__student-numbers"
              >
                <div class="form-inline">
                  <input type="hidden" formControlName="node" />
                  <input
                    type="number"
                    step="1"
                    formControlName="overriddenStudentNumbers"
                    class="form-control"
                    aria-labelledby="nodes-editor-thead-student-numbers"
                  />
                  <button
                    *ngIf="hasAttachToHierarchyPermission"
                    [disabled]="areFormInteractionsDisabled"
                    (click)="removeNode(index)"
                    class="btn btn-link btn-danger"
                    type="button"
                    aria-label="Detach node from list"
                    i18n-aria-label="@@nodesEditor-button-detachNodeFromList"
                  >
                    <i class="fas fa-minus-circle"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="c-nodes-editor__form__table__node-type"></td>
              <td class="c-nodes-editor__form__table__node-title"></td>
              <td class="c-nodes-editor__form__table__student-numbers">
                <ng-container i18n="@@nodesEditor-label-total"
                  >Total:</ng-container
                >
                {{ totalStudentNumbers }}
              </td>
            </tr>
          </tfoot>
        </table>
      </form>
    </div>
  </ng-container>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-default qa-close"
    i18n="@@nodesEditor-btn-close"
    (click)="onClose()"
  >
    Cancel
  </button>

  <button
    *ngIf="hierarchyEditor.hierarchyAndStudentNumbers"
    [disabled]="
      areFormInteractionsDisabled || !hierarchyAndStudentNumbersForm.valid
    "
    (click)="onSubmit()"
    type="button"
    class="btn btn-primary qa-save"
  >
    <ng-container *ngIf="hierarchyEditor.isSaving">
      <span class="text-center qa-saving-spinner" role="status">
        <i class="fas fa-spinner-third fa-fw fa-spin" aria-hidden="true"></i>
        <span class="sr-only" i18n="@@nodesEditor-spinner-saving"
          >Saving...</span
        >
      </span>
    </ng-container>

    <ng-container i18n="@@nodesEditor-btn-save">Save</ng-container>
  </button>
</div>
